import { call, debounce, put, takeLatest } from 'redux-saga/effects';
import { DashboardActionType, DashboardActions } from './actions';
import {
  getCalendarSold,
  getCalendarCollected,
  getCollectToday,
  getCollectTomorrow,
  getMonthlyChargebacks,
  CalendarData
} from '@card/commonlib';

function* fetchSoldAmounts(action: ReturnType<typeof DashboardActions.fetchSoldAmountsStarted>) {
  try {
    const soldAmounts: CalendarData = yield call(getCalendarSold, action.payload);
    yield put(DashboardActions.fetchSoldAmountsSuccess(soldAmounts));
  } catch (error) {
    yield put(DashboardActions.fetchSoldAmountsError(error));
  }
}
function* fetchCollectedAmounts(
  action: ReturnType<typeof DashboardActions.fetchCollectedAmountsStarted>
) {
  try {
    const soldAmounts: CalendarData = yield call(getCalendarCollected, action.payload);
    yield put(DashboardActions.fetchCollectedAmountsSuccess(soldAmounts));
  } catch (error) {
    yield put(DashboardActions.fetchCollectedAmountsError(error));
  }
}
function* fetchCollectToday() {
  try {
    const soldAmounts: number = yield call(getCollectToday);
    yield put(DashboardActions.fetchCollectTodaySuccess(soldAmounts));
  } catch (error) {
    yield put(DashboardActions.fetchCollectTodayError(error));
  }
}
function* fetchCollectTomorrow() {
  try {
    const soldAmounts: number = yield call(getCollectTomorrow);
    yield put(DashboardActions.fetchCollectTomorrowSuccess(soldAmounts));
  } catch (error) {
    yield put(DashboardActions.fetchCollectTomorrowError(error));
  }
}
function* fetchMonthlyChargebacks() {
  try {
    const soldAmounts: number = yield call(getMonthlyChargebacks);
    yield put(DashboardActions.fetchMonthlyChargebacksSuccess(soldAmounts));
  } catch (error) {
    yield put(DashboardActions.fetchMonthlyChargebacksError(error));
  }
}

export function* dashboardSagas() {
  yield debounce(500, DashboardActionType.FetchSoldAmountsStarted, fetchSoldAmounts);
  yield debounce(500, DashboardActionType.FetchCollectedAmountsStarted, fetchCollectedAmounts);
  yield takeLatest(DashboardActionType.FetchCollectTodayStarted, fetchCollectToday);
  yield takeLatest(DashboardActionType.FetchCollectTomorrowStarted, fetchCollectTomorrow);
  yield takeLatest(DashboardActionType.FetchMonthlyChargebacksStarted, fetchMonthlyChargebacks);
}
